import { render, staticRenderFns } from "./patient-merge-search.vue?vue&type=template&id=46e9e9ad&scoped=true&lang=pug&"
import script from "./patient-merge-search.vue?vue&type=script&lang=ts&"
export * from "./patient-merge-search.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e9e9ad",
  null
  
)

export default component.exports